module.exports = __webpack_public_path__ + "img/centralized.2044ac7.svg";